import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { KPIDuration } from '../../root/company.service';

@Component({
  selector: 'lohi-driver-kpi-statistic',
  templateUrl: './driver-kpi-statistic.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverKpiStatisticComponent {
  @Input() public tooltip: string;
  @Input() public title: string;
  @Input() public cents = true;
  @Input() public priorValue: number;
  @Input() public currentValue: number;
  @Input() public duration: KPIDuration;
  @Input() public loading = false;
  @Input() public currentClass = '';
  @Input() public numberFormat = '1.0-0';
}
